import React, {useEffect, useState} from "react";
import axios from "axios";
import * as Constants from "../../constants/urls";
import {useCookies} from "react-cookie";
import {Drawer} from "@mui/material";
import Header from "../Header/Header";
import RightMenu from "../RightMenu";
import {Link} from "react-router-dom";
import Pagination from "react-js-pagination";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import HonariButton from "../Button/HonariButton";

const AllShipping = (props) => {
    const [state, setState] = React.useState({right: false});
    const [data, setData] = useState(undefined);
    const [cookies, setCookie, removeCookie] = useCookies();


    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({...state, [anchor]: open});
    };
    useEffect(() => {
        getData();
    },[])
    function getData(number=1) {

        const url = Constants.apiUrl + "/api/shipping/paginate?page="+number;
        axios.get(url, {
            headers: {
                Authorization: "Bearer " + cookies.user_server_token,
            },
        })
            .then((r) => {
                setData(r.data);
            })
            .catch((e) => {

            });
    }

    return (
        <React.Fragment>
                 <Breadcrumb title={"ارسال های غیر رایگان"} />

            <div className="row">
                <div className="text-center w-100 my-4">
                <Link to={"/admin/shipping/create"}>
                    <div className="btn btn-danger text-center m-auto">ایجاد</div>
                </Link>
                <Link to={"/admin/shipping/category/create"}>
                    <HonariButton>افزودن محصولات دسته بندی</HonariButton>
                </Link>
                </div>
                <div className="mt-2  table-responsive">
                    <table className="table table-hover  ">
                        <tr>

                            <td>
                                شناسه
                            </td>
                            <td>
                                نام محصول
                            </td>
                            <td>
                                نام بسته
                            </td>
                            <td>
                                وضعیت
                            </td>
                            <td>
                                عملیات
                            </td>
                        </tr>
                        {
                            data != undefined && data.data.map((item, index) => {
                                return (<tr>
                                        <td>
                                            {item.id}
                                        </td>
                                        <td>
                                            {item.pack.product.prodName_fa}
                                        </td>
                                        <td>
                                            {item.pack.label}
                                        </td>
                                        <td>
                                            {item.status ==1?"فعال":"غیرفعال"}
                                        </td>
                                        <td>
                                            <Link to={"/admin/shipping/edit/"+item.id}>
                                                <div className={"btn btn-info"}>ویرایش</div>
                                            </Link>
                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </table>

                </div>
                <div className='pager Page navigation example'>
                {data!=undefined && <Pagination
                    totalItemsCount={data.total}
                    activePage={data.current_page}
                    itemsCountPerPage={data.per_page}
                    onChange={(number) => {
                        getData(number);
                    }}
                    itemClass="page-item"
                    linkClass='page-link'
                    firstPageText="اولین صفحه"
                    lastPageText="آخرین صفحه"
                    nextPageText="بعدی"
                    prevPageText="قبلی"
                    activeClass='pageactive'

                />}
                </div>
            </div>
        </React.Fragment>
    );
};
export default AllShipping;
